<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="showPaymentMethodModal" :data="model" :title="$t('Payment Method')"
                   @show="onShow" size="sm" @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation" :ok-title="$t('Submit')" :is-loading="loading"
                   scrollable>
      <input-widget :label="false" :model="model" attribute="payment_method"
                    type="select2"
                    value-field="value" display-field="${item.key}"
                    :items="paymentMethods"/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import PaymentMethodForm from "@/modules/customer/models/PaymentMethodForm.model";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "PaymentMethodModal",
    components: {InputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new PaymentMethodForm({}),
        showConfirmation: false
      }
    },
    methods: {
      ...mapActions(['togglePaymentMethodModal', 'saveTermsPartialData']),
      async onSubmit() {
        this.loading = true;
        let response = await this.saveTermsPartialData({payment_method: this.model.payment_method});
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.togglePaymentMethodModal(false);
          this.$toast('success', this.$t('Payment method was successfully saved'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      onShow() {
        this.showConfirmation = true;
        this.model = new PaymentMethodForm({payment_method: this.paymentMethod});
      },
      onHidden() {
        this.model = new PaymentMethodForm();
        this.togglePaymentMethodModal(false);
      },
    },
    watch: {
      paymentMethod() {
        this.model = new PaymentMethodForm({payment_method: this.paymentMethod});
      }
    },
    computed: {
      ...globalMapState(['paymentMethods']),
      ...mapState({
        showPaymentMethodModal: state => state.termsData.showPaymentMethodModal,
        paymentMethod: state => state.termsData.payment_method
      }),
    },
  }
</script>

<style lang="scss" scoped>
</style>

